var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadCloudGray600(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6156_1315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 14.1666L10 17.4999M10 17.4999L13.3333 14.1666M10 17.4999V9.99994M17.4 15.0749C18.1245 14.5655 18.6678 13.8384 18.9511 12.9992C19.2343 12.1601 19.2428 11.2525 18.9753 10.4081C18.7078 9.56381 18.1782 8.82669 17.4634 8.30375C16.7486 7.78081 15.8857 7.49925 15 7.49994H13.95C13.6994 6.52317 13.2304 5.61598 12.5784 4.84668C11.9265 4.07737 11.1085 3.46599 10.186 3.05857C9.26356 2.65115 8.26071 2.4583 7.25294 2.49454C6.24518 2.53078 5.25877 2.79517 4.36797 3.2678C3.47717 3.74043 2.70519 4.40898 2.11016 5.22314C1.51513 6.03729 1.11255 6.97582 0.932723 7.96807C0.752897 8.96032 0.800514 9.98044 1.07199 10.9516C1.34346 11.9228 1.83172 12.8198 2.50001 13.5749",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6156_1315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCloudGray600);
export default __webpack_public_path__ + "static/media/download-cloud-gray600.254ed2a9428a6ccad03f58ef8e19d6dd.svg";
export { ForwardRef as ReactComponent };